import { SnapShotFrameIdentity } from '../domain-models/snap-shot-frame-identity';
import { NDateTimeOffsetPropertyViewModel } from './base-type/date-time-offset-property-view-model';
import { ItemViewModel } from './item-view-model';
import type { NumericPropertyViewModelInterface, SnapShotFrameIdentityInterface, SnapShotFrameInterface, SnapShotFrameViewModelInterface, StringPropertyViewModelInterface } from '@nts/std/interfaces';


export class SnapShotFrameViewModel<
    TIdentity extends SnapShotFrameIdentityInterface = SnapShotFrameIdentity,
    TModel extends SnapShotFrameInterface<TIdentity> = SnapShotFrameInterface<TIdentity>
> extends ItemViewModel<TModel, TIdentity> implements SnapShotFrameViewModelInterface {

    get identity(): NumericPropertyViewModelInterface {
        return this.getNumericPropertyViewModel((value) => { this._identity = value; }, this._identity, 'identity');
    }

    get updateUser(): StringPropertyViewModelInterface {
        return this.getStringPropertyViewModel((value) => { this._updateUser = value; }, this._updateUser, 'updateUser');
    }

    get updateUserCode(): NumericPropertyViewModelInterface {
        return this.getNumericPropertyViewModel((value) => { this._updateUserCode = value; }, this._updateUserCode, 'updateUserCode');
    }

    get updateDate(): NDateTimeOffsetPropertyViewModel {
        return this.getNDateTimeOffsetPropertyViewModel((value) => { this._updateDate = value; }, this._updateDate, 'updateDate');
    }

    get creationUser(): StringPropertyViewModelInterface {
        return this.getStringPropertyViewModel((value) => { this._creationUser = value; }, this._creationUser, 'creationUser');
    }

    get creationUserCode(): NumericPropertyViewModelInterface {
        return this.getNumericPropertyViewModel((value) => { this._creationUserCode = value; }, this._creationUserCode, 'creationUserCode');
    }

    get creationDate(): NDateTimeOffsetPropertyViewModel {
        return this.getNDateTimeOffsetPropertyViewModel((value) => { this._creationDate = value; }, this._creationDate, 'creationDate');
    }

    private _identity: NumericPropertyViewModelInterface;
    private _updateUser: StringPropertyViewModelInterface;
    private _updateUserCode: NumericPropertyViewModelInterface;
    private _updateDate: NDateTimeOffsetPropertyViewModel;
    private _creationUser: StringPropertyViewModelInterface;
    private _creationUserCode: NumericPropertyViewModelInterface;
    private _creationDate: NDateTimeOffsetPropertyViewModel;

    override async postInit(): Promise<void> {
        await super.postInit();
        this.creationDate.showTime = true;
        this.updateDate.showTime = true;
    }
}
